export default "__VITE_ASSET__BfihRXEi__"